import Login from './views/Login'
import Logout from './views/Logout'
import EnterEvent from './views/EnterEvent'
import { createRoute } from '../../utils/routes'
import ResetPasswordPage from "./views/ResetPasswordPage"

export default {
    enterEvent: createRoute({
        title: 'Event Entry',
        path: '/:eventSlug/enterevent/',
        component: EnterEvent,
        isPublic: true,
    }),
    enterEventBackStage: createRoute({
        title: 'Event Entry',
        path: '/:eventSlug/backstage/',
        component: EnterEvent,
        isPublic: true,
    }),
    login: createRoute({
        title: 'Login',
        path: '/login',
        component: Login,
        isPublic: true,
    }),
    logout: createRoute({
        title: 'Logout',
        path: '/logout',
        component: Logout,
        isPublic: true,
    }),
    resetPassword: createRoute({
        title: 'Reset Password',
        path: '/reset-password',
        component: ResetPasswordPage,
        isPublic: true,
    }),
}
